import { ChangeEvent, FocusEventHandler } from "react";
import { Input } from "antd";

import { EItemFormatType, IItem } from "../../interfaces";

import ErrorMessage from "../ErrorMessage";

interface IProps {
  item: IItem;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  error?: { message: string };
}

export default function Field({
  item,
  onChange,
  onBlur,
  value,
  error,
}: IProps) {
  const hasError = !!error;

  return (
    <div>
      <Input
        placeholder={item.placeholder}
        name={item.id}
        type="text"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        prefix={item?.format === EItemFormatType.CURRENCY ? "R$" : ""}
        maxLength={item?.format === EItemFormatType.CELLPHONE ? 15 : undefined}
        style={{
          background: '#FFFFFF',
          outline: 0,
          padding: "6px 12px",
          borderRadius: 4,
          fontSize: "1rem",
          color: "#212121",
          border: `1px solid ${hasError ? "#ff4d4f" : "#E8E8E8"}`,
        }}
      />

      {
        hasError && (
          <ErrorMessage message={error.message} />
        )
      }
    </div>
  )
}
